import {classNames, _, React, observer, observable, computed, action, useLocalStore} from '@api'
import {Button} from '@blueprintjs/core'
import {Popover2} from '@api'
import {} from '@stores'
import {} from '@modules'
import * as css from './DebugFooterButtons.css'

/// region Store

export class DebugFooterButtonsStore {
  constructor() {
  }

  @observable mustHaveAtLeastOneObservable = true
}

export const DebugFooterButtonsStoreContext = React.createContext<DebugFooterButtonsStore>(null)
export const useDebugFooterButtonsStore = () => React.useContext(DebugFooterButtonsStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const DebugFooterButtons = observer<MyProps>(function DebugFooterButtons({className, ...props}) {
  const store = useLocalStore(() => new DebugFooterButtonsStore())

  return (
    <DebugFooterButtonsStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>
        <Popover2 content={<div>Tree</div>} position='top'>
          <Button icon='tree' text='Diagram' />
        </Popover2>
      </div>
    </DebugFooterButtonsStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/catalog/CatalogFooter/DebugFooterButtons.tsx